<template>
  <div class="baseButton">
    {{nav}}
  </div>
</template>

<script>
  export default {
    props: {
      nav: {
        required: true,
        type: String
      }
    },
    methods: {

    }
  }
</script>

<style lang="scss">
  .baseButton {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-content: center;
    width: 20px;
    border-radius: 50%;
    border: none;
    margin-right: 5px;
    background: rgb(240, 240, 240);
    // height: 100%;
  }
</style>
